import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import './authStyles.scss';

const AuthLayout = (props: any) => {
  return (
    <div className="background-cover min-vh-100">
      <Container className="pb-5 cover-container">
        <Row className="justify-content-center">
          <Col
            className="cover-container-column"
            lg="5"
            md="7"
          >
            {props.children}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AuthLayout;
